import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "title"
}
const _hoisted_3 = {
  key: 1,
  class: "description"
}
const _hoisted_4 = { class: "buttons-container" }



// Props para gestionar el icono, textos y estilos de los botones

export default /*@__PURE__*/_defineComponent({
  __name: 'SuccessOrErrorComponent',
  props: {
    status: {},
    title: {},
    text: {},
    primaryButtonText: {},
    secondaryButtonText: {}
  },
  emits: ['primary-click', 'secondary-click'],
  setup(__props: any) {



// Emitimos eventos para los clics de los botones


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['icon', _ctx.status === 'ok' ? 'ok' : 'error'])
    }, [
      _createElementVNode("i", {
        class: _normalizeClass([ _ctx.status === 'ok' ? 'bp-icon-Approved' : 'bp-icon-Cross'])
      }, null, 2)
    ], 2),
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.title), 1))
      : _createCommentVNode("", true),
    (_ctx.text)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.text), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.secondaryButtonText)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn-outline_black btn-primary-m",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('secondary-click')))
          }, _toDisplayString(_ctx.secondaryButtonText), 1))
        : _createCommentVNode("", true),
      (_ctx.primaryButtonText)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn-primary-green btn-primary-m",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('primary-click')))
          }, _toDisplayString(_ctx.primaryButtonText), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})